// extracted by mini-css-extract-plugin
export default {"download":"LogFilesTableRow-download-sxjYG TableRowCell-cell-giPrj"};